import React, { useMemo } from "react";
import Lottie from "lottie-react";
import MainLoader from "../../assets/animations/MainLoader.json"; // Ensure JSON module support in tsconfig.json

const Loader: React.FC = () => {
  const animationOptions = useMemo(() => ({ animationData: MainLoader, loop: true }), []);

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="w-fit relative">
        <Lottie {...animationOptions} style={{ width: 500, height: 500 }} />
        <div role="presentation" className="absolute h-full w-[150px] right-0 top-0 bg-gray-100 z-10"></div>
      </div>
    </div>
  );
};

export default Loader;
